import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkBadge, UitkBadgeTheme } from './uitk-badge.esm.js';
import { UitkBadgeSize } from '../types.esm.js';

/**
 * @deprecated do not use
 */
var UitkDealBundledBadge = /** @class */function (_super) {
  __extends(UitkDealBundledBadge, _super);
  function UitkDealBundledBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  UitkDealBundledBadge.prototype.render = function () {
    var _a = this.props,
      className = _a.className,
      props = __rest(_a, ["className"]);
    var cssClassNames = classNames(className);
    return React.createElement(UitkBadge, __assign({}, props, {
      size: UitkBadgeSize.LARGE,
      theme: UitkBadgeTheme.DEAL_BUNDLED,
      className: cssClassNames
    }));
  };
  UitkDealBundledBadge.displayName = 'UitkDealBundledBadge';
  return UitkDealBundledBadge;
}(React.PureComponent);
export { UitkDealBundledBadge };